export const GITHUB_RELEASES_URL = 'https://github.proxy.mycryptoapi.com/';
